export default {"src":"/_next/static/media/linkedin_logo_black.edcd3667.svg","height":30,"width":30};